const variants = {
  positive: 'bg-positive/20 text-positive',
  negative: 'bg-negative/20 text-negative',
  neutral: 'bg-neutral/20 text-neutral',
  purple: 'bg-accent/20 text-accent',
  orange: 'bg-accent-warm/20 text-accent-warm',
  gray: 'bg-slate-700/70 text-slate-200',
  win: 'bg-positive/20 text-positive',
  loss: 'bg-negative/20 text-negative',
};

export function Badge({ children, variant = 'gray', className = '' }) {
  return (
    <span className={`px-2 py-0.5 rounded text-xs font-medium ${variants[variant]} ${className}`}>
      {children}
    </span>
  );
}
